module.exports = __webpack_public_path__ + "static/pannonia-cover-atap-72caf76bab5b015f9fbe2a3cb876eef7.jpg";